export default __webpack_public_path__ + "static/media/font.d011af43.jpg";